import { mapState } from 'vuex';
import PageHeader from '@/components/widgets/PageHeader/PageHeader.vue';
import { redirectToAppWithError } from '@/utils/appLoginHelper';

// @vue/component
export default {
  name: 'ErrorMessage',
  components: {
    PageHeader,
  },
  computed: {
    ...mapState({
      error: (state) => state.login.fatalError.error,
      message: (state) => state.login.fatalError.message,
      explanation: (state) => state.login.fatalError.explanation,

      inAppLogin: (state) => state.login.loginType === 'app',
      appInfo: (state) => state.login.appInfo,
      appError: (state) => state.login.fatalError.appError,
      appErrorExplanation: (state) => state.login.fatalError.appErrorExplanation,
    }),
    explanationHTML() {
      return this.explanation.replace(/>/g, '&gt;').replace(/</g, '&lt;').replace(/\\n/g, '<br>');
    },
  },
  methods: {
    onClickBackToApp() {
      redirectToAppWithError(this.appInfo, this.appError, this.appErrorExplanation);
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/sections/ErrorMessage/ErrorMessage.js